import { format } from "date-fns";
import { FORM_KEYS } from "../helper";
import { OTHERS } from "../HospitalizationDetails";
import { Accordion } from "react-bootstrap";

const HospitalizationDetails = ({ formData }) => {
    return (
        <>
            <h6 className="">Hospitalization Details</h6>
            <hr className="m-0 p-0" />
            <div className="row mt-3 px-2">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                    <p className="label">
                        Date & Time of Incidence
                    </p>
                    <p className="value">
                        {format(formData[FORM_KEYS.date_of_incidence], "dd-MM-yyyy")} - {formData[FORM_KEYS.time_of_incidence]}
                    </p>
                </div>
            </div>
            {formData.hospitalizationDetails.map((hospitalizationDetails, index) => (
                <>
                    <Accordion className='accordion mb-2'>
                        <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                                Hospital - {index + 1}
                            </Accordion.Header>
                            <Accordion.Body>

                                <div className="px-2 mt-1">
                                    <h6 className="text-primary">Admitted Details</h6>
                                </div>
                                <div className="row mt-1 px-2">
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Date & Time of Admission
                                        </p>
                                        <p className="value">
                                            {format(hospitalizationDetails[FORM_KEYS.date_of_admission], "dd-MM-yyyy")}
                                            {" "}- {hospitalizationDetails[FORM_KEYS.time_of_admission]}
                                        </p>
                                    </div>

                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Date & Time of Discharge
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.date_of_discharge] ? format(hospitalizationDetails[FORM_KEYS.date_of_discharge], "dd-MM-yyyy") : "--"}
                                            {" - "} {hospitalizationDetails[FORM_KEYS.time_of_discharge]}
                                        </p>
                                    </div>
                                </div>
                                <div className="row px-2 ">
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            No. of days in ICU
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.icu_days] || "--"}
                                        </p>
                                    </div>

                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            No. of days in NON-ICU
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.non_icu_days] || "--"}
                                        </p>
                                    </div>

                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Total No.of Days in Hospital
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.icu_days] || hospitalizationDetails[FORM_KEYS.non_icu_days] ? +(hospitalizationDetails[FORM_KEYS.icu_days]) + +(hospitalizationDetails[FORM_KEYS.non_icu_days]) : "--"}
                                        </p>
                                    </div>
                                </div>
                                <div className="px-2 mt-1">
                                    <h6 className="text-primary">Hospital details</h6>
                                </div>
                                <div className="row mt-1 px-2">
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Hospital Name
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.hospital]?.value === OTHERS? hospitalizationDetails[FORM_KEYS.hospital_name]: hospitalizationDetails[FORM_KEYS.hospital]?.label}
                                        </p>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            State
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.state]?.label || "--"}
                                        </p>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            District
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.district]?.label || "--"}
                                        </p>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Mandal
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.mandal]?.label || "--"}
                                        </p>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            City / Village / Town
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.village]?.label || "--"}
                                        </p>
                                    </div>
                                </div>
                                <div className="px-2 mt-1">
                                    <h6 className="text-primary">Doctor Details</h6>
                                </div>
                                <div className="row mt-1 px-2">
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Doctor Name
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.doctor_name] || "--"}
                                        </p>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Doctor Mobile Number
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.doctor_mobile_number] || "--"}
                                        </p>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Doctor Registration Number
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.doctor_registration_number] || "--"}
                                        </p>
                                    </div>
                                </div>
                                <div className="px-2 mt-1">
                                    <h6 className="text-primary">Ailment & Diagnosis Details</h6>
                                </div>
                                <div className="row mt-1 px-2">
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Reason for Hospitalization
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.reason_of_hospitalization]?.label || "--"}
                                        </p>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                        <p className="label">
                                            Ailment
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.ailment]?.map(item => item.label).join(", ") || "--"}
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-1 px-2">
                                    <div className="col-xl-12">
                                        <p className="label">
                                            Description of Diagnosis
                                        </p>
                                        <p className="value">
                                            {hospitalizationDetails[FORM_KEYS.description_of_diagnosis] || "--"}
                                        </p>
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </>
            ))}
        </>
    );
};

export default HospitalizationDetails;
